<template>
  <div class="contenidor_taula w3-col">
    <div id="contenidor_taula" class="searcher-wrapper">

      <!-- Filters definition -->
      <definition-loader v-if="requestSearcher && requestSearcher.requestDefinition && !loadingDefinitionFilters" v-show="!istoggle"
        :type="getContentType()" :content="requestSearcher" :id="getCurrentContentId()" :taskObject="taskObject" class="searcher-filters"
        @refreshDefinition="refreshSearcherDefinition"
      />

      <transition v-if="requestSearcher" name="fade" mode="out-in">
        <div v-if="loadingResults && requestSearcher.requestDefinition" class="w3-center loadingResults">
          <spinner-loading :line-size='2' :size="23" line-fg-color='#5dbecd' />
        </div>
        <div v-else-if="!loadingResults">
          <div v-if="requestSearcher.requestResult && requestSearcher.requestResult.requestRows.requestColumns.length > 0"
            id="resultados"
            :class="['w3-responsive', 'animated', 'fadeIn', {'detailLoader' : this.externalUrlColumn !== '' || this.idColumn !== '' }, getDefinitionResultsClass()]"
          >
            <searcher-table v-if="getContentType().modeView === 'table'"
              :idColumn="idColumn"
              :idMenuColumn="idMenuColumn"
              :codeColumn="codeColumn"
              :externalUrlColumn="externalUrlColumn"
              :searcherHeader="requestSearcher.requestResult.requestSearcherHeader"
              :rows="requestSearcher.requestResult.requestRows.requestColumns"
              :detailInRow="(idColumn !== '' && currentDetailContent !== null)"
              :detailInRowType="getDetailInRowType"
              :showId="isResultsClass('showId')"
              :contentId="id"
              :showGoToDetail="showGoToDetail"
              @resultSelected="loadResult"
              @refreshHeaderOrder="refreshHeaderOrder"
              @refreshDefinitionContent="refreshDefinitionContent"
            />
            <searcher-gallery v-else-if="isGalleryImage()"
              :idColumn="idColumn"
              :codeColumn="codeColumn"
              :externalUrlColumn="externalUrlColumn"
              :searcherHeader="requestSearcher.requestResult.requestSearcherHeader"
              :rows="requestSearcher.requestResult.requestRows.requestColumns"
              :withLangLegend="isResultsClass('lang-legend')"
              @resultSelected="loadResult"
            />
            <searcher-paginator :requestSearcher="requestSearcher" :downloadingResults="downloadingResults" :isGalleryImage="isGalleryImage()" @refreshPage="refreshPage" @downloadResults="downloadResults" />
          </div>
          <template v-else>
            <div class="noResults">
              <span v-if="!endpointDefined">{{ $ml.get('searcherNotAvailable') }}.</span>
              <span v-else-if="requestSearcher && (requestSearcher.doFirstSearch || definitionLoaded)">{{ $ml.get('noResults') }}.</span>
            </div>
          </template>
        </div>
      </transition>
    </div>

    <router-link v-if="newMenuButton && !isDetailShown"
      :to="{ path: newMenuButton.parentContextPath + newMenuButton.contextPath }"
    >
      <button class="w3-btn w3-round-large new-button">
        <span><i class="sherpa-icon icon-anadir-generico"></i> {{ newMenuButton.name }}</span>
      </button>
    </router-link>

    <!-- DETAIL VIEW -->
    <transition name="fade" mode="out-in">
      <detail v-if="!searcher && isDetailShown && !fromTask"
        :menu="currentContent.subMenu"
        :detailId="idValue"
        @formDataActionCalled="getSearcher(false)"
        @definitionError="definitionError"
      />
    </transition>
  </div>
</template>

<script>
import SearcherPaginator from './paginator'
import SearcherTable from './table'
import SearcherGallery from './gallery'
import Detail from '@/components/content/detail'
import DefinitionLoader from '@/components/content/definitionLoader'
import * as api from '@/utils/api'
import transport from 'vue-definition-utils/src/utils/transport'
import menu from '@/utils/menu'
import * as appTypes from '@/store/actions/app'
import * as authTypes from '@/store/actions/auth'
import SpinnerLoading from 'vue-simple-spinner'
import { mapGetters } from 'vuex'
import Visual from 'vue-definition-utils/src/utils/visual'
import moment from 'moment'
import Configuration from '@/configuration'

export default {
  name: 'searcher',
  props: [
    'searcher',
    'contentId',
    'fromTask',
    'endpointTask',
    'id',
    'code',
    'menuId',
    'taskObject',
    'taskDefinition',
    'istoggle',
    'taskType'
  ],
  data () {
    return {
      requestSearcher: {},
      loadingDefinitionFilters: false,
      loadingResults: true,
      currentContent: null,
      currentDetailContent: null,
      idColumn: null,
      idMenuColumn: null,
      codeColumn: null,
      idValue: null,
      idMenuValue: null,
      codeValue: null,
      externalUrlColumn: null,
      externalUrlValue: null,
      definitionLoaded: false,
      newMenuButton: null,
      endpointDefined: true,
      downloadingResults: false
    }
  },
  components: {
    SearcherTable,
    SearcherGallery,
    SearcherPaginator,
    Detail,
    DefinitionLoader,
    SpinnerLoading
  },
  beforeMount () {
    this.currentContent = this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT}`]
    this.currentDetailContent = this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_CONTENT}`]
    this.getSearcher(true)
  },
  methods: {
    loadResult (row) {
      // external url
      if (this.externalUrlColumn !== '') {
        this.externalUrlValue = this.getRowColumnValue(row, this.externalUrlColumn)
        window.open(this.externalUrlValue)
      } else if (this.idColumn !== '') {
        this.idValue = this.getRowColumnValue(row, this.idColumn)
        this.idMenuValue = this.getRowColumnValue(row, this.idMenuColumn)
        this.codeValue = this.getRowColumnValue(row, this.codeColumn)
        // load detail
        if (this.currentDetailContent === null) {
          // gotoId: menu id to go
          var gotoId = this.currentContent.gotoId

          // check if menu id is defined on 'id-menu' results column
          if (!gotoId) {
            gotoId = this.idMenuValue
          }

          // if not defined, go to first submenu option
          if (!gotoId) {
            var subMenu = this.currentContent.subMenu
            if (subMenu && subMenu.length > 0 && subMenu[0].type && subMenu[0].type.endpoint) {
              gotoId = subMenu[0].id
            }
          }

          if (gotoId) {
            menu.methods.loadDetailView(gotoId, this.idValue, this.codeValue)
          }
        } else if (this.menuId) {
          // if not not defined, go to menuId (from task)
          menu.methods.loadDetailView(this.menuId, this.idValue, this.codeValue)
        }
      }
    },
    getRowColumnValue (id, columnId) {
      return transport.methods.getSearcherColumnValue(id, columnId)
    },
    refreshSearcherDefinition (newRequestObject) {
      this.requestSearcher.requestObject = newRequestObject
      this.getSearcher(false)
    },
    refreshHeaderOrder (id, order) {
      this.requestSearcher.requestResult.requestSearcherHeader = transport.methods.modifyRequestSearcherHeaderValue(this.requestSearcher.requestResult.requestSearcherHeader, id, order)
      this.getSearcher(false)
    },
    refreshPage (pageNumber) {
      this.requestSearcher.requestPage.number = pageNumber
      this.getSearcher(false)
    },
    loadRequestSearcher (searcher, reloadSearcherDefinition) {
      if (reloadSearcherDefinition) {
        this.requestSearcher = searcher
        this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)

        if (this.taskObject && this.taskObject[0]) {
          this.replaceObj(this.requestSearcher.requestObject, this.taskObject[0])
        }
      } else {
        this.requestSearcher.requestPage = searcher.requestPage
        this.requestSearcher.requestObject = searcher.requestObject
        this.requestSearcher.requestResult = searcher.requestResult
      }

      if (this.requestSearcher) {
        if (this.requestSearcher.requestObject === null && this.requestSearcher.requestDefinition) {
          this.requestSearcher.requestObject = transport.methods.getEmptyRequestObject(this.requestSearcher.requestDefinition)
        }
        this.idColumn = transport.methods.getSearcherAliasByType(this.requestSearcher.requestResult.requestSearcherHeader, 'id')
        this.idMenuColumn = transport.methods.getSearcherAliasByType(this.requestSearcher.requestResult.requestSearcherHeader, 'id-menu')
        this.codeColumn = transport.methods.getSearcherAliasByType(this.requestSearcher.requestResult.requestSearcherHeader, 'code')
        this.externalUrlColumn = transport.methods.getSearcherAliasByType(this.requestSearcher.requestResult.requestSearcherHeader, 'externalUrl')

        this.loadingResults = false
        if (reloadSearcherDefinition) {
          this.loadingDefinitionFilters = false
        }
      } else {
        this.loadingResults = false
        this.loadingDefinitionFilters = false
        // open error service dialog
        this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_STATUS_ERROR}`, {response: {status: 500}})
      }
      this.$emit('searcherLoaded')
    },
    getSearcher (reloadSearcherDefinition) {
      this.loadingResults = true
      if (reloadSearcherDefinition) {
        this.loadingDefinitionFilters = true
        this.requestSearcher = {}
        this.idColumn = null
        this.codeColumn = null
        this.externalUrlColumn = null
        this.idValue = null
        this.codeValue = null
        this.externalUrlValue = null
        this.definitionLoaded = false
        this.newMenuButton = menu.methods.getNewMenuOfSearcherOption(this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_MENU}`], this.id)
      } else {
        this.definitionLoaded = true
      }

      if (this.searcher && reloadSearcherDefinition) {
        this.loadRequestSearcher(this.searcher, reloadSearcherDefinition)
      } else if (this.currentContent.type) {
        var endpoint = this.getSearcherEndpoint()

        // endpoint not defined
        if (!endpoint) {
          this.endpointDefined = false
          this.loadingResults = false
          this.loadingDefinitionFilters = false
          this.requestSearcher.requestResult = null
          this.$emit('searcherLoaded')
          this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
        } else {
          this.endpointDefined = true
          api.call({
            access: api.ACCESS_SERVICES,
            url: endpoint,
            method: 'POST',
            data: {
              requestSearcher: this.requestSearcher,
              id: this.id,
              code: this.code
            }
          })
            .then(resp => {
              if (resp.requestResult) {
                this.loadRequestSearcher(resp.requestSearcher, reloadSearcherDefinition)
              }
            })
            .catch(err => {
              this.loadingResults = false
              this.loadingDefinitionFilters = false
              this.requestSearcher.requestResult = null
              // open error service dialog
              this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_STATUS_ERROR}`, err)
              this.$emit('searcherLoaded')
            })
        }
      }
    },
    getSearcherEndpoint () {
      var result = this.currentContent.type.endpoint
      if (this.fromTask) {
        result = this.endpointTask
      } else if (this.searcher) {
        result = this.currentDetailContent.endpoint
      }
      return result
    },
    getCurrentContentId () {
      var result = null
      if (this.contentId) {
        result = this.contentId
      } else {
        result = this.currentContent.id
      }
      return result
    },
    getDefinitionResultsClass () {
      var result = ''
      var visualDefinition = new Visual(this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_VISUALS}`], this.getCurrentContentId())
      if (visualDefinition.definition) {
        result = visualDefinition.definition.resultsClass
      }
      return result
    },
    isResultsClass (classToCheck) {
      var result = false
      var resultsClass = this.getDefinitionResultsClass()
      if (resultsClass && resultsClass !== '') {
        var classes = resultsClass.split(' ')
        for (var i = 0; i < classes.length && !result; i++) {
          result = (classes[i] === classToCheck)
        }
      }
      return result
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    replaceObj (lReqObj, obj) {
      var found = false

      if (lReqObj && lReqObj.length > 0) {
        for (var i = 0; i < lReqObj.length && !found; i++) {
          var reqObj = this.requestSearcher.requestObject[i]
          if (reqObj.id === obj.id) {
            reqObj.domainValue = obj.domainValue
            reqObj.textValue = obj.textValue
            reqObj.languageValue = obj.languageValue
            reqObj.complexDomainValue = obj.complexDomainValue
            found = true
          } else {
            found = this.replaceObj(reqObj.children, obj)
          }
        }
      }

      if (obj.children) {
        for (var j = 0; j < obj.children.length; j++) {
          this.replaceObj(lReqObj, obj.children[j])
        }
      }

      return found
    },
    definitionError (error, resultError, container) {
      this.$emit('definitionError', error, resultError, container)
    },
    getContentType () {
      var result
      if (this.taskType) {
        result = this.taskType
      } else {
        result = this.currentContent.type
      }
      return result
    },
    downloadResults () {
      var endpoint = this.getSearcherEndpoint()
      if (endpoint) {
        this.downloadingResults = true
        api.call({
          access: api.ACCESS_SERVICES,
          url: endpoint + '/download',
          method: 'POST',
          blobMode: true,
          data: {
            requestSearcher: this.requestSearcher,
            id: this.id,
            code: this.code
          }
        })
          .then(resp => {
            var fileName = this.getFileName(resp)
            var fileDownload = require('js-file-download')
            fileDownload(resp.data, fileName)
            this.downloadingResults = false
          })
          .catch(err => {
            this.downloadingResults = false
            console.error(err)
            this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_STATUS_ERROR}`, err)
          })
      }
    },
    getFileName (resp) {
      var fileName = ''

      var contentDisposition = resp.request.getResponseHeader('Content-Disposition')
      var fileNameMatch = contentDisposition.match(/filename=(.+)/)
      if (fileNameMatch && fileNameMatch.length === 2) {
        fileName = fileNameMatch[1]
      }
      if (this.currentContent && this.currentContent.name) {
        var extension = fileName.substring(fileName.lastIndexOf('.'))
        fileName = this.currentContent.name
        if (this.currentDetailContent && this.currentDetailContent.name) {
          fileName += ' - ' + this.currentDetailContent.name
        }
        if (this.taskDefinition && this.taskDefinition.label && this.taskDefinition.label !== '') {
          fileName += ' - ' + this.taskDefinition.label
        }
        var definitionTitle = this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_TITLE}`]
        if (definitionTitle && definitionTitle !== '') {
          let indexSpan = definitionTitle.indexOf(' <span')
          if (indexSpan > -1) {
            definitionTitle = definitionTitle.substring(0, indexSpan)
          }
          fileName += ' - ' + definitionTitle
        }
        fileName += extension
      }
      return fileName
    },
    isGalleryImage () {
      return this.getContentType().modeView === 'gallery'
    },
    searchDetailInRowType (lMenu, menuIds) {
      let result = null
      console.log('searchDetailInRowType')
      if (lMenu) {
        for (var i = 0; i < lMenu.length && !result; i++) {
          var currentMenu = lMenu[i]
          if (menuIds.includes(currentMenu.id)) {
            result = currentMenu.type
            result.domainEndpoint = Configuration.value('API_SERVICES_URL') + moment().valueOf()
            result.content = {
              id: currentMenu.id,
              name: currentMenu.name
            }
          }
          if (!result) {
            result = this.searchDetailInRowType(currentMenu.subMenu, menuIds)
          }
        }
      }
      return result
    }
  },
  computed: {
    newCurrentContent () {
      return this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT}`]
    },
    newCurrentDetailContent () {
      return this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_CONTENT}`]
    },
    ...mapGetters(`${appTypes.APP_NAMESPACE}`, [`${appTypes.APP_DETAIL_SHOWN}`]),
    getDetailInRowType () {
      var result = null
      if (this.menuId) {
        var menuIds = this.menuId.split(',')
        result = this.searchDetailInRowType(this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_MENU}`], menuIds)
      }
      return result
    },
    showGoToDetail () {
      var result

      result = (
        this.idColumn !== '' && this.currentContent.subMenu && this.currentContent.subMenu[0] && this.currentContent.subMenu[0].type && this.currentContent.subMenu[0].type.endpoint
      ) ||
      (this.idColumn !== '' && this.idMenuColumn !== '') ||
      this.externalUrlColumn !== ''

      return result
    }
  },
  watch: {
    newCurrentContent (newCurrentContent) {
      this.currentContent = newCurrentContent
      this.getSearcher(true)
    },
    newCurrentDetailContent (newCurrentDetailContent) {
      this.currentDetailContent = newCurrentDetailContent

      if (!newCurrentDetailContent) {
        this.getSearcher(false)
        this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
      } else if ((newCurrentDetailContent && this.contentId) || (newCurrentDetailContent && this.fromTask)) {
        this.getSearcher(true)
      }
    },
    taskObject: {
      handler: function (val) {
        if (val && val[0]) {
          this.replaceObj(this.requestSearcher.requestObject, val[0])
          this.getSearcher(false)
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.contenidor_taula {
  .searcher-filters {
    border-bottom: 1px solid #e4e4e4;
  }

  .loadingResults {
    position: relative;
    padding-top: 100px;
    padding-bottom: 200px;
  }

  .noResults {
    padding: 100px;
    text-align: center;
    min-height: 400px;
    color: #048198;
    font-size: 15px;
  }

  #resultados {
    padding-bottom: 200px;
  }
}
.new-button {
  position: fixed;
  bottom: 10px;
  right: 20px;
  padding: 0 20px;
  height: 45px;
  border-radius: 0;
  background-color: #d42e12;
  -webkit-transition: all .2s ease-in;
  transition: all .2s ease-in;

  span {
    font-family: "Source Sans Pro", sans-serif;
    font-weight: 600;
    font-size: 20px;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;

    i {
      font-size: 14px;
    }
  }
}
#content .lds-dual-ring {
  position: relative;
}
#content .lds-dual-ring div {
  position: absolute;
  width: 160px;
  height: 160px;
  top: 20px;
  left: 20px;
  border-radius: 50%;
  border: 8px solid #000;
  border-color: #ffffff transparent #ffffff transparent;
  -webkit-animation: lds-dual-ring 1s linear infinite;
  animation: lds-dual-ring 1s linear infinite;
}
#content .lds-dual-ring {
  width: 70px !important;
  height: 70px !important;
  -webkit-transform: translate(-35px, -35px) scale(0.35) translate(35px, 35px);
  transform: translate(-35px, -35px) scale(0.35) translate(35px, 35px);
}
.definition-wrapper.group {
  display: inline-block;
}
.definition-container {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/content/searcher/index.vue